import React from 'react';

const prefix = 'nxt';
const iconName = 'dnd';
const width = 10;
const height = 10;
const unicode = '';
const svgPathData = '';

const definition = {
  prefix: prefix,
  nxtCustom: true,
  iconName: iconName,
  icon: [width, height, unicode, svgPathData],
  iconDom: (
    <>
      <rect fill="#DB3545" height="10" id="container" rx="5" width="10" />
      <rect fill="white" height="2" id="dash" rx="0.4" width="6" x="2.1" y="4" />
    </>
  ),
};

const nxtDND = definition;

export { definition, nxtDND, prefix, iconName, width, height, unicode, svgPathData };
